import '../../assets/index46.css';var G = Object.defineProperty, q = Object.defineProperties;
var J = Object.getOwnPropertyDescriptors;
var R = Object.getOwnPropertySymbols;
var $ = Object.prototype.hasOwnProperty, k = Object.prototype.propertyIsEnumerable;
var O = (n, e, t) => e in n ? G(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, C = (n, e) => {
  for (var t in e || (e = {}))
    $.call(e, t) && O(n, t, e[t]);
  if (R)
    for (var t of R(e))
      k.call(e, t) && O(n, t, e[t]);
  return n;
}, H = (n, e) => q(n, J(e));
var E = (n, e) => {
  var t = {};
  for (var r in n)
    $.call(n, r) && e.indexOf(r) < 0 && (t[r] = n[r]);
  if (n != null && R)
    for (var r of R(n))
      e.indexOf(r) < 0 && k.call(n, r) && (t[r] = n[r]);
  return t;
};
import { jsx as S, jsxs as P } from "react/jsx-runtime";
import * as _ from "react";
import L, { useLayoutEffect as U, useState as X } from "react";
import { ErrorMessage as Z } from "../../molecules/ErrorMessage/index.js";
import { Label as D } from "../Label/index.js";
import { g as K } from "../../get-env-CiXMSQeN.js";
import { f as ee, u as te } from "../../factory-ueRxoNOV.js";
import { I as Y } from "../../InputBase-Cabx1d9o.js";
function W() {
  return W = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, W.apply(null, arguments);
}
function re(n, e) {
  if (n == null) return {};
  var t = {};
  for (var r in n) if ({}.hasOwnProperty.call(n, r)) {
    if (e.indexOf(r) !== -1) continue;
    t[r] = n[r];
  }
  return t;
}
var ne = U, ie = function(e) {
  var t = L.useRef(e);
  return ne(function() {
    t.current = e;
  }), t;
}, j = function(e, t) {
  if (typeof e == "function") {
    e(t);
    return;
  }
  e.current = t;
}, oe = function(e, t) {
  var r = L.useRef();
  return L.useCallback(function(i) {
    e.current = i, r.current && j(r.current, null), r.current = t, t && j(t, i);
  }, [t]);
}, B = {
  "min-height": "0",
  "max-height": "none",
  height: "0",
  visibility: "hidden",
  overflow: "hidden",
  position: "absolute",
  "z-index": "-1000",
  top: "0",
  right: "0",
  display: "block"
}, ae = function(e) {
  Object.keys(B).forEach(function(t) {
    e.style.setProperty(t, B[t], "important");
  });
}, M = ae, o = null, V = function(e, t) {
  var r = e.scrollHeight;
  return t.sizingStyle.boxSizing === "border-box" ? r + t.borderSize : r - t.paddingSize;
};
function se(n, e, t, r) {
  t === void 0 && (t = 1), r === void 0 && (r = 1 / 0), o || (o = document.createElement("textarea"), o.setAttribute("tabindex", "-1"), o.setAttribute("aria-hidden", "true"), M(o)), o.parentNode === null && document.body.appendChild(o);
  var i = n.paddingSize, s = n.borderSize, d = n.sizingStyle, h = d.boxSizing;
  Object.keys(d).forEach(function(f) {
    var v = f;
    o.style[v] = d[v];
  }), M(o), o.value = e;
  var a = V(o, n);
  o.value = e, a = V(o, n), o.value = "x";
  var p = o.scrollHeight - i, u = p * t;
  h === "border-box" && (u = u + i + s), a = Math.max(u, a);
  var g = p * r;
  return h === "border-box" && (g = g + i + s), a = Math.min(g, a), [a, p];
}
var Q = function() {
}, de = function(e, t) {
  return e.reduce(function(r, i) {
    return r[i] = t[i], r;
  }, {});
}, ue = [
  "borderBottomWidth",
  "borderLeftWidth",
  "borderRightWidth",
  "borderTopWidth",
  "boxSizing",
  "fontFamily",
  "fontSize",
  "fontStyle",
  "fontWeight",
  "letterSpacing",
  "lineHeight",
  "paddingBottom",
  "paddingLeft",
  "paddingRight",
  "paddingTop",
  // non-standard
  "tabSize",
  "textIndent",
  // non-standard
  "textRendering",
  "textTransform",
  "width",
  "wordBreak",
  "wordSpacing",
  "scrollbarGutter"
], le = !!document.documentElement.currentStyle, ce = function(e) {
  var t = window.getComputedStyle(e);
  if (t === null)
    return null;
  var r = de(ue, t), i = r.boxSizing;
  if (i === "")
    return null;
  le && i === "border-box" && (r.width = parseFloat(r.width) + parseFloat(r.borderRightWidth) + parseFloat(r.borderLeftWidth) + parseFloat(r.paddingRight) + parseFloat(r.paddingLeft) + "px");
  var s = parseFloat(r.paddingBottom) + parseFloat(r.paddingTop), d = parseFloat(r.borderBottomWidth) + parseFloat(r.borderTopWidth);
  return {
    sizingStyle: r,
    paddingSize: s,
    borderSize: d
  };
}, fe = ce;
function N(n, e, t) {
  var r = ie(t);
  _.useLayoutEffect(function() {
    var i = function(d) {
      return r.current(d);
    };
    if (n)
      return n.addEventListener(e, i), function() {
        return n.removeEventListener(e, i);
      };
  }, []);
}
var pe = function(e, t) {
  N(document.body, "reset", function(r) {
    e.current.form === r.target && t(r);
  });
}, he = function(e) {
  N(window, "resize", e);
}, ge = function(e) {
  N(document.fonts, "loadingdone", e);
}, ve = ["cacheMeasurements", "maxRows", "minRows", "onChange", "onHeightChange"], me = function(e, t) {
  var r = e.cacheMeasurements, i = e.maxRows, s = e.minRows, d = e.onChange, h = d === void 0 ? Q : d, a = e.onHeightChange, p = a === void 0 ? Q : a, u = re(e, ve), g = u.value !== void 0, f = _.useRef(null), v = oe(f, t), F = _.useRef(0), z = _.useRef(), m = function() {
    var l = f.current, y = r && z.current ? z.current : fe(l);
    if (y) {
      z.current = y;
      var w = se(y, l.value || l.placeholder || "x", s, i), b = w[0], T = w[1];
      F.current !== b && (F.current = b, l.style.setProperty("height", b + "px", "important"), p(b, {
        rowHeight: T
      }));
    }
  }, I = function(l) {
    g || m(), h(l);
  };
  return _.useLayoutEffect(m), pe(f, function() {
    if (!g) {
      var x = f.current.value;
      requestAnimationFrame(function() {
        var l = f.current;
        l && x !== l.value && m();
      });
    }
  }), he(m), ge(m), /* @__PURE__ */ _.createElement("textarea", W({}, u, {
    onChange: I,
    ref: v
  }));
}, _e = /* @__PURE__ */ _.forwardRef(me);
const xe = {}, A = ee((n, e) => {
  const u = te(
    "Textarea",
    xe,
    n
  ), { autosize: t, maxRows: r, minRows: i, __staticSelector: s, resize: d } = u, h = E(u, ["autosize", "maxRows", "minRows", "__staticSelector", "resize"]), a = t && K() !== "test", p = a ? { maxRows: r, minRows: i } : {};
  return /* @__PURE__ */ S(
    Y,
    C(H(C({
      component: a ? _e : "textarea",
      ref: e
    }, h), {
      __staticSelector: s || "Textarea",
      multiline: !0,
      "data-no-overflow": t && r === void 0 || void 0,
      __vars: { "--input-resize": d }
    }), p)
  );
});
A.classes = Y.classes;
A.displayName = "@mantine/core/Textarea";
const be = "TextField-module__root___9xSbN", Se = "TextField-module__wrapper___fLJF-", ze = "TextField-module__input___shQrf", ye = "TextField-module__section___PMsf6", Fe = "TextField-module__label___yB4jx", we = "TextField-module__error___sL5lp", Te = "TextField-module__description___uE3y4", Re = "TextField-module__textFieldWrapper___-QVQ9", Ce = "TextField-module__characterCountContainer___OR9eO", Le = "TextField-module__resizable___cVY6c", He = "TextField-module__resizeHandle___-SIBV", c = {
  root: be,
  wrapper: Se,
  input: ze,
  section: ye,
  label: Fe,
  error: we,
  description: Te,
  textFieldWrapper: Re,
  characterCountContainer: Ce,
  resizable: Le,
  resizeHandle: He
}, Pe = L.forwardRef((I, m) => {
  var x = I, {
    error: n,
    rightSection: e,
    multiline: t,
    maxRows: r = 5,
    minRows: i = 1,
    label: s,
    withAsterisk: d,
    required: h,
    className: a,
    characterCount: p,
    maxLength: u,
    value: g = "",
    onChange: f,
    resizable: v,
    width: F
  } = x, z = E(x, [
    "error",
    "rightSection",
    "multiline",
    "maxRows",
    "minRows",
    "label",
    "withAsterisk",
    "required",
    "className",
    "characterCount",
    "maxLength",
    "value",
    "onChange",
    "resizable",
    "width"
  ]);
  const [l, y] = X(g), w = (T) => {
    y(T.target.value), f && f(T);
  }, b = typeof s == "string" ? /* @__PURE__ */ S(D, { label: s, withAsterisk: h }) : s;
  return /* @__PURE__ */ P("div", { className: c.textFieldWrapper, children: [
    /* @__PURE__ */ S(
      A,
      H(C({
        classNames: {
          root: `${c.root} ${a || ""}`,
          input: `${c.input} ${t && v ? c.resizable : ""}`,
          wrapper: c.wrapper,
          section: c.section,
          label: c.label,
          error: c.error,
          description: c.description
        },
        inputWrapperOrder: ["label", "input", n ? "error" : "description"],
        autosize: !0,
        maxRows: r,
        minRows: i,
        error: n && /* @__PURE__ */ S(Z, { error: n }),
        value: l,
        onChange: w,
        maxLength: u,
        style: { width: F }
      }, z), {
        ref: m,
        component: t ? void 0 : "input",
        label: b,
        rightSection: e
      })
    ),
    p && /* @__PURE__ */ S("div", { className: c.characterCountContainer, children: /* @__PURE__ */ P("span", { children: [
      l.length,
      u ? ` / ${u}` : ""
    ] }) }),
    t && v && /* @__PURE__ */ S("div", { className: c.resizeHandle })
  ] });
});
export {
  Pe as TextField
};
